import React from 'react';

const buildClassName = ({
  variant,
  size,
  fullWidth,
  loading,
  className,
}) =>
  [
    'app-btn',
    `app-btn--${variant}`,
    `app-btn--${size}`,
    fullWidth ? 'app-btn--full' : '',
    loading ? 'app-btn--loading' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

/**
 * Shared action button with consistent variants, sizing and loading state.
 */
export const AppButton = ({
  as = 'button',
  type = 'button',
  variant = 'primary',
  size = 'md',
  className,
  children,
  disabled = false,
  loading = false,
  icon = null,
  iconPosition = 'left',
  fullWidth = false,
  onClick,
  ...rest
}) => {
  const Component = as;
  const isDisabled = disabled || loading;
  const commonClassName = buildClassName({
    variant,
    size,
    fullWidth,
    loading,
    className,
  });

  const iconNode = icon ? <span className="app-btn__icon">{icon}</span> : null;

  const content = (
    <>
      {loading && <span className="app-btn__spinner" aria-hidden="true" />}
      {iconNode && iconPosition === 'left' ? iconNode : null}
      <span className="app-btn__label">{children}</span>
      {iconNode && iconPosition === 'right' ? iconNode : null}
    </>
  );

  if (Component === 'a') {
    return (
      <a
        className={commonClassName}
        aria-disabled={isDisabled}
        onClick={
          isDisabled
            ? (event) => {
                event.preventDefault();
              }
            : onClick
        }
        {...rest}
      >
        {content}
      </a>
    );
  }

  return (
    <Component
      type={type}
      className={commonClassName}
      disabled={isDisabled}
      onClick={onClick}
      {...rest}
    >
      {content}
    </Component>
  );
};

